// TIBECO - Documente HR - Gestionarea documentelor pentru echipa de 11 angajați
import React, { useState } from 'react';
import { 
  FileText, Download, Upload, Search, Filter, Eye, Edit3, Trash2, Plus, 
  Calendar, User, Clock, CheckCircle, AlertTriangle, Star, Folder,
  FileImage, FileSpreadsheet, File, Archive, Share2, Lock,
  Factory, Award, Shield, Users, Target
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';
import { mockData, getDepartmentColor } from '../../utils/mockData';

const HRDocuments = () => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('Toate');
  const [filterEmployee, setFilterEmployee] = useState('Toți');

  // Documente HR pentru echipa TIBECO
  const hrDocuments = [
    {
      id: 1,
      name: 'Contract de Muncă - Aostăcioaei Ciprian',
      type: 'Contract Muncă',
      employee: 'Aostăcioaei Dumitru - Ciprian',
      department: 'Management',
      category: 'Contracte',
      uploadDate: '2020-01-15',
      lastModified: '2024-01-15',
      size: '2.4 MB',
      format: 'PDF',
      status: 'Activ',
      confidentiality: 'Confidențial',
      expiryDate: '2025-01-15',
      version: '2.1',
      description: 'Contract de muncă pe perioadă nedeterminată - Manager General',
      tags: ['Contract', 'Manager', 'Principal'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: File
    },
    {
      id: 2,
      name: 'Fișă Post - Inginer Proiecte',
      type: 'Fișă Post',
      employee: 'Filip Paul - Ionel',
      department: 'Tehnică',
      category: 'Fișe Post',
      uploadDate: '2020-09-01',
      lastModified: '2023-09-01',
      size: '1.8 MB',
      format: 'PDF',
      status: 'Activ',
      confidentiality: 'Intern',
      expiryDate: '2025-09-01',
      version: '1.3',
      description: 'Fișă de post pentru poziția de Inginer Proiecte - responsabilități tehnice',
      tags: ['Fișă Post', 'Tehnică', 'Proiectare'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: FileText
    },
    {
      id: 3,
      name: 'Certificat SSM - Echipa Montaj',
      type: 'Certificat',
      employee: 'Ungureanu Ștefan',
      department: 'Montaj',
      category: 'Certificări',
      uploadDate: '2024-01-10',
      lastModified: '2024-01-10',
      size: '890 KB',
      format: 'PDF',
      status: 'Activ',
      confidentiality: 'Public',
      expiryDate: '2025-01-10',
      version: '1.0',
      description: 'Certificat de Siguranță și Sănătate în Muncă pentru activități de montaj',
      tags: ['SSM', 'Certificat', 'Montaj', 'Obligatoriu'],
      createdBy: 'Inspector SSM',
      approvedBy: 'Ministerul Muncii',
      fileIcon: Award
    },
    {
      id: 4,
      name: 'Evaluare Performanță - Trimestrul I 2024',
      type: 'Evaluare',
      employee: 'Bărbosu Mihăiță - Daniel',
      department: 'Producție',
      category: 'Evaluări',
      uploadDate: '2024-03-31',
      lastModified: '2024-03-31',
      size: '1.2 MB',
      format: 'DOCX',
      status: 'Finalizat',
      confidentiality: 'Confidențial',
      expiryDate: null,
      version: '1.0',
      description: 'Evaluare de performanță trimestrială - Șef Echipă Producție',
      tags: ['Evaluare', 'Performanță', 'Producție'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: Target
    },
    {
      id: 5,
      name: 'Plan Concedii 2024 - TIBECO',
      type: 'Planificare',
      employee: 'Toți angajații',
      department: 'General',
      category: 'Planificări',
      uploadDate: '2023-12-15',
      lastModified: '2024-03-10',
      size: '650 KB',
      format: 'XLSX',
      status: 'Activ',
      confidentiality: 'Intern',
      expiryDate: '2024-12-31',
      version: '1.4',
      description: 'Planificarea anuală a concediilor pentru toată echipa TIBECO',
      tags: ['Concedii', 'Planificare', '2024'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: FileSpreadsheet
    },
    {
      id: 6,
      name: 'Adeverință Salariat - Cojocariu Beniamin',
      type: 'Adeverință',
      employee: 'Cojocariu Beniamin',
      department: 'Producție',
      category: 'Adeverințe',
      uploadDate: '2024-02-20',
      lastModified: '2024-02-20',
      size: '420 KB',
      format: 'PDF',
      status: 'Emis',
      confidentiality: 'Confidențial',
      expiryDate: '2024-08-20',
      version: '1.0',
      description: 'Adeverință de salariat pentru băncă - solicitare credit',
      tags: ['Adeverință', 'Salariat', 'Bancă'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Cazacu Denisa - Elena',
      fileIcon: FileText
    },
    {
      id: 7,
      name: 'Regulament Intern TIBECO 2024',
      type: 'Regulament',
      employee: 'Toți angajații',
      department: 'General',
      category: 'Regulamente',
      uploadDate: '2024-01-01',
      lastModified: '2024-02-15',
      size: '3.2 MB',
      format: 'PDF',
      status: 'Activ',
      confidentiality: 'Intern',
      expiryDate: null,
      version: '2.0',
      description: 'Regulament intern de organizare și funcționare TIBECO - actualizat 2024',
      tags: ['Regulament', 'Intern', 'TIBECO', '2024'],
      createdBy: 'Cazacu Denisa - Elena',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: FileText
    },
    {
      id: 8,
      name: 'Instructaj SSM - Producție Ferestre',
      type: 'Instructaj',
      employee: 'Echipa Producție',
      department: 'Producție',
      category: 'Instructaje',
      uploadDate: '2024-01-08',
      lastModified: '2024-01-08',
      size: '1.1 MB',
      format: 'PDF',
      status: 'Obligatoriu',
      confidentiality: 'Intern',
      expiryDate: '2025-01-08',
      version: '1.0',
      description: 'Instructaj de securitate și sănătate în muncă pentru activitatea de producție',
      tags: ['SSM', 'Instructaj', 'Producție', 'Obligatoriu'],
      createdBy: 'Inspector SSM',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: Shield
    },
    {
      id: 9,
      name: 'Cerere Concediu - Moroșan Noemia',
      type: 'Cerere Concediu',
      employee: 'Moroșan Noemia',
      department: 'Marketing',
      category: 'Cereri',
      uploadDate: '2024-01-10',
      lastModified: '2024-01-12',
      size: '280 KB',
      format: 'PDF',
      status: 'Aprobat',
      confidentiality: 'Confidențial',
      expiryDate: null,
      version: '1.0',
      description: 'Cerere pentru concediu de creștere copil - ianuarie 2024',
      tags: ['Concediu', 'Maternal', 'Cerere'],
      createdBy: 'Moroșan Noemia',
      approvedBy: 'Aostăcioaei Dumitru - Ciprian',
      fileIcon: FileText
    },
    {
      id: 10,
      name: 'Certificat Calificare - Murariu Eusebiu',
      type: 'Certificat',
      employee: 'Murariu Iulian - Eusebiu',
      department: 'Montaj',
      category: 'Certificări',
      uploadDate: '2023-11-25',
      lastModified: '2023-11-25',
      size: '950 KB',
      format: 'PDF',
      status: 'Activ',
      confidentiality: 'Public',
      expiryDate: '2026-11-25',
      version: '1.0',
      description: 'Certificat de calificare profesională pentru montaj ferestre și uși',
      tags: ['Calificare', 'Montaj', 'Certificat'],
      createdBy: 'Camera Meșteșugarilor',
      approvedBy: 'Camera Meșteșugarilor',
      fileIcon: Award
    }
  ];

  // Statistici documente
  const documentStats = {
    totalDocuments: hrDocuments.length,
    activeDocuments: hrDocuments.filter(doc => doc.status === 'Activ').length,
    expiringSoon: hrDocuments.filter(doc => {
      if (!doc.expiryDate) return false;
      const expiryDate = new Date(doc.expiryDate);
      const now = new Date();
      const threeMonths = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate());
      return expiryDate <= threeMonths && expiryDate > now;
    }).length,
    confidentialDocs: hrDocuments.filter(doc => doc.confidentiality === 'Confidențial').length
  };

  const documentTypes = ['Toate', 'Contract Muncă', 'Fișă Post', 'Certificat', 'Evaluare', 'Planificare', 'Adeverință', 'Regulament', 'Instructaj', 'Cerere Concediu'];

  const filteredDocuments = hrDocuments.filter(doc => {
    const matchesSearch = doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         doc.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())) ||
                         doc.employee.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'Toate' || doc.type === filterType;
    const matchesEmployee = filterEmployee === 'Toți' || doc.employee === filterEmployee || doc.employee === 'Toți angajații';
    return matchesSearch && matchesType && matchesEmployee;
  });

  const getStatusColor = (status) => {
    switch (status) {
      case 'Activ': return 'success';
      case 'Finalizat': return 'info';
      case 'Emis': return 'warning';
      case 'Obligatoriu': return 'error';
      case 'Aprobat': return 'success';
      default: return 'secondary';
    }
  };

  const getConfidentialityColor = (confidentiality) => {
    switch (confidentiality) {
      case 'Confidențial': return 'error';
      case 'Intern': return 'warning';
      case 'Public': return 'success';
      default: return 'secondary';
    }
  };

  const getFileIcon = (format) => {
    switch (format.toLowerCase()) {
      case 'pdf': return File;
      case 'docx':
      case 'doc': return FileText;
      case 'xlsx':
      case 'xls': return FileSpreadsheet;
      default: return FileText;
    }
  };

  const isExpiringSoon = (expiryDate) => {
    if (!expiryDate) return false;
    const expiry = new Date(expiryDate);
    const now = new Date();
    const threeMonths = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate());
    return expiry <= threeMonths && expiry > now;
  };

  const documentColumns = [
    {
      header: 'Document',
      key: 'name',
      render: (value, row) => {
        const FileIcon = getFileIcon(row.format);
        return (
          <div className="flex items-center space-x-3">
            <FileIcon className={`w-5 h-5 ${
              row.format === 'PDF' ? 'text-red-500' :
              row.format === 'DOCX' ? 'text-blue-500' :
              row.format === 'XLSX' ? 'text-green-500' : 'text-gray-500'
            }`} />
            <div>
              <p className="font-semibold text-gray-900 dark:text-white text-sm">{value}</p>
              <p className="text-xs text-gray-500">{row.description}</p>
              <div className="flex items-center space-x-1 mt-1">
                <Badge variant="secondary" className="text-xs">{row.type}</Badge>
                <Badge variant={getConfidentialityColor(row.confidentiality)} className="text-xs">
                  {row.confidentiality}
                </Badge>
              </div>
            </div>
          </div>
        );
      }
    },
    {
      header: 'Angajat/Departament',
      key: 'employee',
      render: (value, row) => (
        <div>
          <p className="font-medium text-gray-900 dark:text-white text-sm">{value}</p>
          <Badge variant={getDepartmentColor(row.department)} className="text-xs mt-1">
            {row.department}
          </Badge>
        </div>
      )
    },
    {
      header: 'Status & Date',
      key: 'status',
      render: (value, row) => (
        <div className="space-y-2">
          <Badge variant={getStatusColor(value)} className="text-xs">{value}</Badge>
          <div className="text-xs text-gray-500">
            <div>Upload: {new Date(row.uploadDate).toLocaleDateString('ro-RO')}</div>
            {row.expiryDate && (
              <div className={isExpiringSoon(row.expiryDate) ? 'text-red-600 font-medium' : ''}>
                Expiră: {new Date(row.expiryDate).toLocaleDateString('ro-RO')}
                {isExpiringSoon(row.expiryDate) && ' ⚠️'}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      header: 'Detalii',
      key: 'details',
      render: (_, row) => (
        <div className="text-xs text-gray-500">
          <div>Mărime: {row.size}</div>
          <div>Versiune: v{row.version}</div>
          <div>Creat: {row.createdBy}</div>
          <div>Aprobat: {row.approvedBy}</div>
        </div>
      )
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (_, row) => (
        <div className="flex items-center space-x-2">
          <button 
            onClick={() => {
              setSelectedDocument(row);
              setShowDocumentModal(true);
            }}
            className="text-primary-600 hover:text-primary-800 dark:text-primary-400"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          <button 
            className="text-blue-600 hover:text-blue-800 dark:text-blue-400"
            title="Descarcă"
          >
            <Download className="w-4 h-4" />
          </button>
          <button 
            className="text-gray-600 hover:text-gray-800 dark:text-gray-400"
            title="Editează"
          >
            <Edit3 className="w-4 h-4" />
          </button>
          <button 
            className="text-green-600 hover:text-green-800 dark:text-green-400"
            title="Partajează"
          >
            <Share2 className="w-4 h-4" />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-4">
          <Factory className="w-8 h-8 text-primary-600" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Documente HR TIBECO
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Gestionarea documentelor pentru echipa de 11 angajați specializați în ferestre și uși
            </p>
          </div>
        </div>
        
        <button
          onClick={() => setShowUploadModal(true)}
          className="btn btn-primary flex items-center gap-2"
        >
          <Plus className="w-4 h-4" />
          Document Nou
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Documente</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{documentStats.totalDocuments}</p>
              <p className="text-sm text-gray-500">Pentru 11 angajați</p>
            </div>
            <FileText className="w-8 h-8 text-primary-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active</p>
              <p className="text-2xl font-bold text-green-600">{documentStats.activeDocuments}</p>
              <p className="text-sm text-gray-500">În vigoare</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Expiră Curând</p>
              <p className="text-2xl font-bold text-yellow-600">{documentStats.expiringSoon}</p>
              <p className="text-sm text-gray-500">Sub 3 luni</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-yellow-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Confidențiale</p>
              <p className="text-2xl font-bold text-red-600">{documentStats.confidentialDocs}</p>
              <p className="text-sm text-gray-500">Acces restricționat</p>
            </div>
            <Lock className="w-8 h-8 text-red-600" />
          </div>
        </Card>
      </div>

      {/* Filters and Table */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4 mb-6">
          <div className="flex-1 relative">
            <Search className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
            <input
              type="text"
              placeholder="Caută documente, angajați, tags..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </div>
          
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            {documentTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
          
          <select
            value={filterEmployee}
            onChange={(e) => setFilterEmployee(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="Toți">Toți angajații</option>
            {mockData.employees.map(employee => (
              <option key={employee.id} value={employee.name}>{employee.name}</option>
            ))}
            <option value="Toți angajații">Documente generale</option>
          </select>
        </div>

        <Table 
          columns={documentColumns}
          data={filteredDocuments}
        />
      </Card>

      {/* Upload Modal */}
      <Modal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        title="Adăugare Document HR"
        size="lg"
      >
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Tip Document</label>
              <select className="form-select">
                <option>Contract Muncă</option>
                <option>Fișă Post</option>
                <option>Certificat</option>
                <option>Evaluare</option>
                <option>Adeverință</option>
                <option>Regulament</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">Angajat TIBECO</label>
              <select className="form-select">
                <option value="">Selectează angajat</option>
                {mockData.employees.map(employee => (
                  <option key={employee.id} value={employee.name}>{employee.name}</option>
                ))}
                <option value="general">Document general</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Titlu Document</label>
            <input type="text" className="form-input" placeholder="Ex: Contract de muncă..." />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Descriere</label>
            <textarea className="form-input" rows={3} placeholder="Descriere detaliată..."></textarea>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Confidențialitate</label>
              <select className="form-select">
                <option>Confidențial</option>
                <option>Intern</option>
                <option>Public</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">Data Expirare</label>
              <input type="date" className="form-input" />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2">Tags</label>
              <input type="text" className="form-input" placeholder="Tag1, Tag2, Tag3" />
            </div>
          </div>

          <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center">
            <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600 dark:text-gray-400 mb-2">Drag & drop fișierul sau</p>
            <button className="btn btn-secondary">Selectează Fișier</button>
            <p className="text-xs text-gray-500 mt-2">PDF, DOC, DOCX, XLS, XLSX până la 10MB</p>
          </div>

          <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700">
            <button
              onClick={() => setShowUploadModal(false)}
              className="btn btn-secondary"
            >
              Anulează
            </button>
            <button className="btn btn-primary">
              Adaugă Document
            </button>
          </div>
        </div>
      </Modal>

      {/* Document Detail Modal */}
      {selectedDocument && (
        <Modal
          isOpen={showDocumentModal}
          onClose={() => {
            setShowDocumentModal(false);
            setSelectedDocument(null);
          }}
          title={selectedDocument.name}
          size="lg"
        >
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Informații Document</h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Tip:</span>
                      <Badge variant="secondary" className="text-xs">{selectedDocument.type}</Badge>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Format:</span>
                      <span className="font-medium">{selectedDocument.format}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Mărime:</span>
                      <span className="font-medium">{selectedDocument.size}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Versiune:</span>
                      <span className="font-medium">v{selectedDocument.version}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Status:</span>
                      <Badge variant={getStatusColor(selectedDocument.status)} className="text-xs">
                        {selectedDocument.status}
                      </Badge>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Confidențialitate</h4>
                  <Badge variant={getConfidentialityColor(selectedDocument.confidentiality)} className="text-xs">
                    {selectedDocument.confidentiality}
                  </Badge>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Angajat/Departament</h4>
                  <div className="space-y-1">
                    <p className="font-medium">{selectedDocument.employee}</p>
                    <Badge variant={getDepartmentColor(selectedDocument.department)} className="text-xs">
                      {selectedDocument.department}
                    </Badge>
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Date Importante</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Upload:</span>
                      <span>{new Date(selectedDocument.uploadDate).toLocaleDateString('ro-RO')}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Modificat:</span>
                      <span>{new Date(selectedDocument.lastModified).toLocaleDateString('ro-RO')}</span>
                    </div>
                    {selectedDocument.expiryDate && (
                      <div className="flex justify-between">
                        <span className="text-gray-500">Expiră:</span>
                        <span className={isExpiringSoon(selectedDocument.expiryDate) ? 'text-red-600 font-medium' : ''}>
                          {new Date(selectedDocument.expiryDate).toLocaleDateString('ro-RO')}
                          {isExpiringSoon(selectedDocument.expiryDate) && ' ⚠️'}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Creat/Aprobat</h4>
                  <div className="space-y-1 text-sm">
                    <div>Creat de: <span className="font-medium">{selectedDocument.createdBy}</span></div>
                    <div>Aprobat de: <span className="font-medium">{selectedDocument.approvedBy}</span></div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-medium text-gray-900 dark:text-white mb-2">Descriere</h4>
              <p className="text-gray-600 dark:text-gray-400 text-sm">{selectedDocument.description}</p>
            </div>

            <div>
              <h4 className="font-medium text-gray-900 dark:text-white mb-2">Tags</h4>
              <div className="flex flex-wrap gap-2">
                {selectedDocument.tags?.map((tag, index) => (
                  <Badge key={index} variant="info" className="text-xs">
                    {tag}
                  </Badge>
                ))}
              </div>
            </div>

            <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700">
              <button
                onClick={() => {
                  setShowDocumentModal(false);
                  setSelectedDocument(null);
                }}
                className="btn btn-secondary"
              >
                Închide
              </button>
              <button className="btn btn-success">
                <Download className="w-4 h-4 mr-2" />
                Descarcă
              </button>
              <button className="btn btn-primary">
                <Edit3 className="w-4 h-4 mr-2" />
                Editează
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default HRDocuments;